module.exports = __webpack_public_path__ + "media/astronaut_ocean.87bb860b.mp3";